import React from 'react';
import Col from 'react-bootstrap/Col';
import { createUseStyles } from 'react-jss';
import Slider from '../../components/Slider';
import Text from '../../components/Text';
import ProductCard from '../../components/ProductCard';
import Loader from '../../components/Loader';
import { Settings } from 'react-slick';
import { Link } from 'react-router-dom';

export interface GroupItemProps extends Settings {
    title: string,
    type: 'product' | 'twig',
    viewAll?: boolean
    href?: string,
    list: any[],
    loader: boolean,
    trackName?: string;
}

const GroupItem: React.FC<GroupItemProps> = ({ title, type, list, loader, viewAll, href, trackName, ...other }) => {
    const classes = useStyles();

    return (
        <>
            <Col xs={12}>

                <div className={classes.productsBox}>
                    <Text bold className={classes.text}>{title}</Text>
                    {viewAll && href ?
                        <Link className={classes.viewAll} to={href}>View All</Link>
                        : null}
                    <Loader className={classes.loader} center loading={loader}>
                        {() => (

                            <Slider {...other}>
                                {list.map((item) => (
                                    <div
                                        key={item.id}
                                        className={classes.productSlideWrapper}
                                    >
                                        {type == 'product' ? (
                                            <ProductCard
                                                trackName={trackName}
                                                className={classes.productSlide}
                                                product={item}
                                            />
                                        ) : null}
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </Loader>
                </div>
            </Col>
        </>
    )
}

const useStyles = createUseStyles({
    loader: {
        minHeight: '400px',
    },
    viewAll: {
        color: "#522583",
        position: "absolute",
        right: "5px",
        top: "6px",
        "&:hover": {
            color: "#522583",
            textDecoration: "underline"
        }
    },
    container: {
        marginTop: '30px',
    },
    productsBox: {
        position: 'relative',
    },
    text: {
        fontSize: "1.5rem",
        margin: '15px 0px !important',
    },
    productSlideWrapper: {
        paddingLeft: '10px',
        paddingRight: '10px',
        minHeight: '405px',
        display: 'flex !important',
        flexDirection: 'column',
        position: 'relative'

    },
    productSlide: {
        flex: 1,
    },
    twigsBox: {
        marginTop: '30px',
    },
    twigsLoader: {
        minHeight: '50vh',
    },
    twigsWrapper: {
        display: 'flex',
        width: 'auto',
    },
    twigWrapper: {
        margin: '1rem',
        position: 'relative'
    },
    loadingMoreBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '20px',
    },
});

export default GroupItem